export const leaderboardQueryKey = (query = {}) => JSON.stringify([
  query.metric || 'body_rank', query.direction || 'desc', query.band ?? null, query.page || 1, !!query.findMe,
]);

export const leaderboardQuery = search => {
  const params = new URLSearchParams(search);
  const band = Number(params.get('band'));
  const page = Number(params.get('page'));
  return { metric: params.get('metric') || 'body_rank', direction: params.get('direction') === 'asc' ? 'asc' : 'desc',
    page: Number.isInteger(page) && page > 0 ? page : 1,
    ...(params.has('band') && Number.isInteger(band) && band >= 0 && band <= 9 ? { band } : {}),
    ...(params.get('findMe') === 'true' ? { findMe: true } : {}) };
};
